import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=c086d496&"
import script from "./MyTeam.vue?vue&type=script&lang=ts&"
export * from "./MyTeam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports